module.exports = __webpack_public_path__ + "img/28141158000109.9c9e21b3.png";